export class StartSparkJobDirectParams {
    'jobTimeout';
    'retryPolicy';
    'sparkSubmitParams';
    'storageConfig';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "jobTimeout",
            "baseName": "jobTimeout",
            "type": "number",
            "format": ""
        },
        {
            "name": "retryPolicy",
            "baseName": "retryPolicy",
            "type": "SparkJobRetryPolicy",
            "format": ""
        },
        {
            "name": "sparkSubmitParams",
            "baseName": "sparkSubmitParams",
            "type": "SparkJobSparkSubmitParams",
            "format": ""
        },
        {
            "name": "storageConfig",
            "baseName": "storageConfig",
            "type": "StorageConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartSparkJobDirectParams.attributeTypeMap;
    }
    constructor() {
    }
}
